import { render, staticRenderFns } from "./ProjectTasksComponent.vue?vue&type=template&id=61c8decc&scoped=true"
import script from "./ProjectTasksComponent.vue?vue&type=script&lang=js"
export * from "./ProjectTasksComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectTasksComponent.vue?vue&type=style&index=0&id=61c8decc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8decc",
  null
  
)

export default component.exports